import script from "./AppSideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSideMenu.vue?vue&type=script&setup=true&lang=js"

import "./AppSideMenu.vue?vue&type=style&index=0&id=a5ee886a&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5ee886a"]])

export default __exports__